var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonAndRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5.25C9.45435 5.25 8.69129 5.56607 8.12868 6.12868C7.56607 6.69129 7.25 7.45435 7.25 8.25C7.25 9.04565 7.56607 9.80871 8.12868 10.3713C8.69129 10.9339 9.45435 11.25 10.25 11.25C11.0456 11.25 11.8087 10.9339 12.3713 10.3713C12.9339 9.80871 13.25 9.04565 13.25 8.25C13.25 7.45435 12.9339 6.69129 12.3713 6.12868C11.8087 5.56607 11.0456 5.25 10.25 5.25ZM44 28.5L42.5 20.25L35.75 7.5L32 9.75L29 18L23.75 19.5L18.2 29.85L17 28.5L20 21L16.25 18L11 24L5.75 27L3.5 39.3H45.5L44 28.5ZM32.75 26.25L32 30L28.25 31.5L30.5 28.5V26.25L32.75 23.25L33.5 24.75L32.75 26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonAndRock);
export default __webpack_public_path__ + "static/media/moon-and-rock.56f2791370a93b1e0c3a288eaf43fe22.svg";
export { ForwardRef as ReactComponent };